/* eslint-disable no-unused-vars */
import db from '@/plugins/dexie';
import apiempresaweb from '@/services/api-varejoweb';

export default {
  namespaced: true,

  state: {
    list: [],
  },

  getters: {
    list: (state) => state.list,
  },

  // NUNCA ALTERAR state DIRETAMENTE EM ACTIONS
  actions: {
    async find({ dispatch }, {
      where, ...params
    } = {}) {
      dispatch('scroll/count', { where, ...params, tabela: 'produto' }, { root: true });
      const [{ data }] = await Promise.all([
        apiempresaweb.get('produto/prevenda', { params: { ...where, ...params } }),
      ]);
      return data;
    },

    async findFood(_, idgrupo) {
      const [{ data }] = await Promise.all([
        apiempresaweb.get('produto/food'),
      ]);

      return data.data;
    },
  },

  // APENAS O MUTATION FAZ ALTERAÇÕES NO STATE
  mutations: {
    SET_LIST(state, list) {
      state.list = list ?? [];
    },
  },
};
